// Sdílené formátovací helpery + měsíční osa pro finanční moduly (AOP, Výsledovka…).
// Jedno místo pravdy — dřív byly tyto funkce zkopírované v každé AOP vrstvě zvlášť.

export const MESICE_SHORT = ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čvn', 'Čvc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro'];
export const MESICE_PLNE = ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'];

// Klíče měsíčních sloupců v datech: m01 … m12
export const MKEYS = Array.from({ length: 12 }, (_, i) => `m${String(i + 1).padStart(2, '0')}`);

// Číslo → bezpečná číselná hodnota (prázdné/null → 0)
export const num = (v) => (v === '' || v == null ? 0 : Number(v) || 0);

// Formátované celé číslo v cs-CZ (1 234 567); prázdné/null → pomlčka
export const fmt = (v) => (v == null || v === '' ? '—' : new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 0 }).format(Math.round(Number(v))));

// Jako fmt, ale se suffixem „ Kč"
export const fmtKc = (v) => (v == null || v === '' ? '—' : fmt(v) + ' Kč');

// Procenta na 1 desetinné místo: 4.2 → „4.2 %" (zachováno stávající chování Materiálu)
export const pct1 = (v) => `${(Number(v) || 0).toFixed(1)} %`;
